import produce from 'immer';
import _forEachRight from 'lodash/forEachRight';

import initialState from '../initialState/contentLibrary';
import * as contentLibraryActionTypes from '../../constants/actionTypes/contentLibrary';

const contentLibrary = (state = initialState, action) => produce(state, (draftState) => {
    switch (action.type) {
        case contentLibraryActionTypes.SET_FOLDERS:
            draftState.folders = action.payload || [];
            // We want to have the first folder selected as we open the modal
            if (action.payload && action.payload.length > 0) {
                draftState.selectedFolder.id = action.payload[0].folderID;
            }
            break;
        case contentLibraryActionTypes.SET_ACTIVE_FOLDER:
            draftState.selectedFolder.id = action.payload.folderID;
            draftState.selectedFolder.contents = action.payload.contents;
            break;
        case contentLibraryActionTypes.SET_FOLDER_CONTENTS:
            draftState.selectedFolder.contents = action.payload || [];
            break;
        case contentLibraryActionTypes.UPDATE_FOLDERS:
            draftState.folders.push(action.payload);
            break;
        case contentLibraryActionTypes.UPDATE_FOLDER_NAME: {
            const { folders } = draftState;
            const folderIndex = folders.findIndex((folder) => folder.folderID === action.payload.folderID);
            if (folderIndex >= 0) {
                draftState.folders[folderIndex].folderName = action.payload.folderName;
            }
            break;
        }
        case contentLibraryActionTypes.UPDATE_CONTENT_NAME: {
            const { selectedFolder } = draftState;
            const { contents } = selectedFolder;
            const contentIndex = contents.findIndex((content) => content.contentID === action.payload.contentID);
            if (contentIndex >= 0) {
                draftState.selectedFolder.contents[contentIndex].displayName = action.payload.displayName;
            }
            break;
        }
        case contentLibraryActionTypes.UPDATE_FOLDER_CONTENT: {
            const { content, method } = action.payload;

            if (method === contentLibraryActionTypes.UPDATE_CONTENT_INSERTION_METHOD.APPEND) {
                content.forEach((image) => draftState.selectedFolder.contents.push(image));
            } else {
                _forEachRight(content, (image) => draftState.selectedFolder.contents.unshift(image));
            }

            draftState.isLoading = false;
            break;
        }
        case contentLibraryActionTypes.DELETE_FOLDER:
            draftState.folders = draftState.folders.filter((folder) => folder.folderID !== action.payload);
            break;
        case contentLibraryActionTypes.DELETE_FOLDER_CONTENT: {
            const deletedContents = action.payload;
            const { selectedFolder } = draftState;
            const { contents } = selectedFolder;
            deletedContents.forEach((deletedContent) => {
                const contentIndex = contents.findIndex((content) => content.contentID === deletedContent.contentID);
                if (contentIndex >= 0) {
                    contents.splice(contentIndex, 1);
                }
            });
            break;
        }
        case contentLibraryActionTypes.SET_LOADING:
            draftState.isLoading = action.payload;
            break;
        default:
            return state;
    }
});

export default contentLibrary;
